import styled, { css } from 'styled-components'

const cssInput = css`
	appearance: none;
	background-color: rgb(23, 40, 51) !important; // rgba(238, 238, 238, 0.05);
	border: 1px solid transparent !important;
	border-radius: 0.25rem !important;
	padding: 0.5rem 0.75rem !important;
	color: #fff !important;
	font-size: clamp(14px, 1rem, 16px) !important;
	line-height: 1.5 !important;

	&:-webkit-autofill,
	&:-webkit-autofill:hover, 
	&:-webkit-autofill:focus, 
	&:-webkit-autofill:active {
		-webkit-border-before-color: transparent;
		-webkit-border-image: none;
		-webkit-font-smoothing: antialiased;
		-webkit-box-shadow:0 0 0 50px rgb(23, 40, 51) inset; /* Change the color to your own background color */
    -webkit-text-fill-color: #fff;
	}
	& {
		/* font-size: 0.75rem; */
		display: block;
		width: 100%;
	}
	&::placeholder {
		color: var(--it-text-grey);
	}
`
const cssInvalid = css`
	&[data-invalid="true"] {
		/* border-color: #f44336; */
		border-color: #E4281B; // rgba(244, 67, 54, 1);
		border-width: 1px;
	}
`
const cssValid = css`
	&[data-valid="true"] {
		/* border-color: #4caf50; */
		border-color: #16BC53; // rgba(76, 175, 80, 1);
		border-width: 1px;
	}
`

export const Elemet = styled.div`
	//background: rgb(13, 30, 41); // rgba(238, 238, 238, 0.05);
	//background-color: #15262f; //TODO: check the color after redesign all PWA
	color: #fff;
	font-size: clamp(14px, 0.75rem, 16px);
	white-space: nowrap;
	&[data-inline="false"] {
		display: flex;
		flex-direction: column;
		margin-bottom: 1rem;
		gap: 0.5rem;
	}
	&[data-inline="true"] {
		display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
		gap: 0.5rem;
	}
	&[data-inline-extended="true"] {
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			align-items: flex-start;
			gap: 0.75rem;

      //TODO: check the media point transition
      @media all and (max-width: 1200px) {
          flex-direction: column;
      }
	}
	&[data-type="hidden"] {
		display: none;
	}
	&[data-padding="true"] {
		padding: 6px 10px;
	}

	&[data-full-width-selection="true"] {
			margin-bottom: 2px;
	}
		
	&[data-hidden="true"] {
			display: none;
	}
`

export const CheckElement = styled.div`
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
	gap: 6px;
	cursor: pointer;

	&[data-check-elemet]:not(:hover) > input:not(:checked) ~ label > div[data-check-icon]:not([data-checked]):not([data-hover]) {
		display: inline-flex;
	}
	&[data-check-elemet]:hover > input:not(:checked) ~ label > div[data-check-icon]:not([data-checked])[data-hover] {
		display: inline-flex;
	}
	&[data-check-elemet]:not(:hover) > input:checked ~ label > div[data-check-icon][data-checked]:not([data-hover]) {
		display: inline-flex;
	}
	&[data-check-elemet]:hover > input:checked ~ label > div[data-check-icon][data-checked][data-hover] {
		display: inline-flex;
	}

	&[data-check-elemet] > input:checked ~ label {
      &[data-full-width-selection="true"] {
          background-color: var(--it-bg-buttons);
      }
	}

	&[data-check-elemet]:hover > input:not(:checked) ~ label {
      &[data-full-width-selection="true"] {
          background-color: var(--it-bg-buttons);
			}
	}
`

export const RadioElement = styled.div`
	display: flex;
	flex-flow: row nowrap;
	justify-content: flex-start;
	align-items: center;
	gap: 6px;
	cursor: pointer;

	&[data-radio-elemet]:not(:hover) > input:not(:checked) ~ label > div[data-radio-icon]:not([data-checked]):not([data-hover]) {
		display: inline-flex;
	}
	&[data-radio-elemet]:hover > input:not(:checked) ~ label > div[data-radio-icon]:not([data-checked])[data-hover] {
		display: inline-flex;
	}
	&[data-radio-elemet]:not(:hover) > input:checked ~ label > div[data-radio-icon][data-checked]:not([data-hover]) {
		display: inline-flex;
	}
	&[data-radio-elemet]:hover > input:checked ~ label > div[data-radio-icon][data-checked][data-hover] {
		display: inline-flex;
	}
`

export const Error = styled.div`
	/* color: #f44336; */
	color: #E4281B; // rgba(244, 67, 54, 1);
	font-size: 0.75rem;
	white-space: nowrap;
	&[data-white-space="normal"] {
		white-space: normal;
	}
	&[data-inline="false"] {}
	&[data-inline="true"] {}
`

export const Success = styled.div`
	/* color: #4caf50; */
	color: #16BC53; // rgba(76, 175, 80, 1);
	font-size: 0.75rem;
	white-space: nowrap;
	&[data-white-space="normal"] {
		white-space: normal;
	}
	&[data-inline="false"] {}
	&[data-inline="true"] {}
`

export const Hint = styled.div`
	/* color: #9e9e9e; */
	color: var(--it-text-grey);
	font-size: 0.75rem;
	white-space: nowrap;
	&[data-white-space="normal"] {
		white-space: normal;
	}
	&[data-inline="false"] {}
	&[data-inline="true"] {}
`

export const Label = styled.label`
	/* text-transform: uppercase; */
	white-space: nowrap;
	&[data-check], &[data-radio] {
		display: inline-flex;
		justify-content: flex-start;
		align-items: flex-start;
		gap: 6px;
		line-height: 120%;
		white-space: wrap;
		cursor: pointer;

		&[data-full-width-selection="true"] {
				width: 100%;
				padding: 10px;
				margin-left: 0;
		}
	}
		
	&[data-bold="false"] {
		font-weight: normal;
	}
	&[data-bold="true"] {
		font-weight: bold;
	}
	&[data-inline="false"] {}
	&[data-inline="true"] {}
    
	&[data-inline-extended="true"] {
			width: 270px;
			white-space: wrap;
      word-break: break-all;
      text-transform: uppercase;
		
      //TODO: check the media point transition
      @media all and (max-width: 1200px) {
          width: 100%;
      }
	}
		
	&[data-disabled="true"] {
		color: #626B6F;
	}
	&[data-valid="true"] {
		color: #16BC53;
	}
	&[data-invalid="true"] {
		color: #E4281B;
	}
`

export const Input = styled.input`
	${cssInput}
	${cssValid}
	${cssInvalid}
	
	&[data-inline="false"] {
		//TODO: check superposition of margin-s in cases of multiple elements in 1 row usage
		//margin-bottom: 1rem;
	}
	&[data-inline="true"] {}
		
	&[data-inline-extended="true"] {
			display: flex;
			flex: 1 1;
			
      //TODO: check the media point transition
      @media all and (max-width: 1200px) {
					margin-left: 0.5rem;
      }
	}

	&[data-disabled="true"] {
		color: var(--it-text-disabled) !important;
		background-color: var(--it-bg-buttons) !important; //TODO: check the bg-color for disabled inputs
	}
`

export const Textarea = styled.textarea`
	${cssInput}
	${cssValid}
	${cssInvalid}
	&[data-inline="false"] {}
	&[data-inline="true"] {}
`

export const Check = styled.input`
	display: none;
`

export const Radio = styled.input`
	display: none;
`

export const CheckIcon = styled.div`
	display: none;
	justify-content: center;
	align-items: center;
`

export const RadioIcon = styled.div`
	display: none;
	justify-content: center;
	align-items: center;
`

export const stylesReactSelect = {
  clearIndicator: (styles, props) => ({
		...styles,
		backgroundColor: 'transparent',
		color: '#E4281B',
		'&:hover': {
			...styles['&:hover'],
			backgroundColor: 'transparent',	
			color: '#E4281B',
		},
	}),
  container: (styles, props) => ({ ...styles, }),
  control: (styles, props) => ({
		...styles,
		appearance: 'none',
		backgroundColor: 'rgb(23, 40, 51)',
		border: '1px solid transparent',
		color: '#fff',
		boxShadow: 'none',
		'&:hover': {
			...styles['&:hover'],
			backgroundColor: 'rgb(23, 40, 51)',
			border: '1px solid transparent',
			color: '#fff',
		},
	}),
  dropdownIndicator: (styles, props) => ({
		...styles,
		backgroundColor: 'rgb(23, 40, 51)',
		border: '1px solid transparent',
		color: '#fff',
		'&:hover': {
			...styles['&:hover'],
			backgroundColor: 'rgb(23, 40, 51)',
			border: '1px solid transparent',
			color: '#fff',
		},
	}),
  group: (styles, props) => ({ ...styles, }),
  groupHeading: (styles, props) => ({ ...styles, }),
  indicatorsContainer: (styles, props) => ({ ...styles, }),
  indicatorSeparator: (styles, props) => ({ ...styles, }),
  input: (styles, props) => ({
		...styles,
		backgroundColor: 'rgb(23, 40, 51)',
		border: '1px solid transparent',
		color: '#fff',
		boxShadow: 'none',
		'&:hover': {
			...styles['&:hover'],
			backgroundColor: 'rgb(23, 40, 51)',
			border: '1px solid transparent',
			color: '#fff',
		},
	}),
  loadingIndicator: (styles, props) => ({ ...styles, }),
  loadingMessage: (styles, props) => ({
		...styles,
		backgroundColor: 'rgb(23, 40, 51)',
		border: '1px solid transparent',
		color: '#fff',
		boxShadow: 'none',
		'&:hover': {
			...styles['&:hover'],
			backgroundColor: 'rgb(23, 40, 51)',
			border: '1px solid transparent',
			color: '#fff',
		},
	}),
  menu: (styles, props) => ({
		...styles,
		backgroundColor: 'rgb(23, 40, 51)',
		'&:hover': {
			...styles['&:hover'],
			backgroundColor: 'rgb(23, 40, 51)',
		},
	}),
  menuList: (styles, props) => ({ ...styles, }),
  menuPortal: (styles, props) => ({ ...styles, }),
  multiValue: (styles, props) => ({
		...styles,
		backgroundColor: 'rgba(238, 238, 238, 0.05)',
		'&:hover': {
			...styles['&:hover'],
			backgroundColor: 'rgba(238, 238, 238, 0.05)',
		},
	}),
  multiValueLabel: (styles, props) => ({
		...styles,
		color: '#fff',
		'&:hover': {
			...styles['&:hover'],
			color: '#fff',
		},
	}),
  multiValueRemove: (styles, props) => ({
		...styles,
		backgroundColor: 'transparent',
		color: '#E4281B',
		'&:hover': {
			...styles['&:hover'],
			backgroundColor: 'transparent',	
			color: '#E4281B',
		},
	}),
  noOptionsMessage: (styles, props) => ({
		...styles,
		backgroundColor: 'rgb(23, 40, 51)',
		border: '1px solid transparent',
		color: '#fff',
		boxShadow: 'none',
		'&:hover': {
			...styles['&:hover'],
			backgroundColor: 'rgb(23, 40, 51)',
			border: '1px solid transparent',
			color: '#fff',
		},
	}),
  option: (styles, props) => ({
		...styles,
		backgroundColor: 'transparent',
		color: '#fff',
		'&:hover': {
			...styles['&:hover'],
			backgroundColor: 'transparent',
			color: '#fff',
		},
	}),
  placeholder: (styles, props) => ({
		...styles,
		color: 'rgba(255, 255, 255, 0.60)',
		//color: `var(--it-text-grey)`,
	}),
  singleValue: (styles, props) => ({
		...styles,
		backgroundColor: 'rgb(23, 40, 51)',
		border: '1px solid transparent',
		color: '#fff',
		'&:hover': {
			...styles['&:hover'],
			backgroundColor: 'rgb(23, 40, 51)',
			border: '1px solid transparent',
			color: '#fff',
		},
	}),
  valueContainer: (styles, props) => ({ ...styles, }),
}

export const stylesReactDatetime = css`
	.rdt {
		position: relative;
	}
	.rdt input {
		${cssInput}
	}
	.rdtPicker {
		display: none;
		position: absolute;
		background-color: rgb(23, 40, 51);
		width: 250px;
		padding: 4px;
		margin-top: 1px;
		z-index: 99999 !important;
	}
	.rdtOpen .rdtPicker {
		display: block;
	}
	.rdtStatic .rdtPicker {
		box-shadow: none;
		position: static;
	}

	.rdtPicker .rdtTimeToggle {
		text-align: center;
	}

	.rdtPicker table {
		width: 100%;
		margin: 0;
	}
	.rdtPicker td,
	.rdtPicker th {
		text-align: center;
		height: 28px;
	}
	.rdtPicker td {
		cursor: pointer;
	}
	.rdtPicker td.rdtDay:hover,
	.rdtPicker td.rdtHour:hover,
	.rdtPicker td.rdtMinute:hover,
	.rdtPicker td.rdtSecond:hover,
	.rdtPicker .rdtTimeToggle:hover {
		cursor: pointer;
	}
	.rdtPicker td.rdtToday {
		position: relative;
	}
	.rdtPicker td.rdtToday:before {
		content: "";
		display: inline-block;
		border-left: 7px solid transparent;
		position: absolute;
		bottom: 4px;
		right: 4px;
	}
	.rdtPicker td.rdtDisabled,
	.rdtPicker td.rdtDisabled:hover {
		background: none;
		cursor: not-allowed;
	}
	.rdtPicker td span.rdtDisabled,
	.rdtPicker td span.rdtDisabled:hover {
		background: none;
		cursor: not-allowed;
	}
	.rdtPicker .dow {
		width: 14.2857%;
		border-bottom: none;
		cursor: default;
	}
	.rdtPicker th.rdtSwitch {
		width: 100px;
	}
	.rdtPicker th.rdtNext,
	.rdtPicker th.rdtPrev {
		font-size: 21px;
		vertical-align: top;
	}

	.rdtPrev span,
	.rdtNext span {
		display: block;
		-webkit-touch-callout: none; /* iOS Safari */
		-webkit-user-select: none; /* Chrome/Safari/Opera */
		-khtml-user-select: none; /* Konqueror */
		-moz-user-select: none; /* Firefox */
		-ms-user-select: none; /* Internet Explorer/Edge */
		user-select: none;
	}

	.rdtPicker th.rdtDisabled,
	.rdtPicker th.rdtDisabled:hover {
		background: none;
		cursor: not-allowed;
	}
	.rdtPicker thead tr:first-child th {
		cursor: pointer;
	}
	.rdtPicker button {
		border: none;
		background: none;
		cursor: pointer;
	}
	.rdtPicker thead button {
		width: 100%;
		height: 100%;
	}

	td.rdtMonth,
	td.rdtYear {
		height: 50px;
		width: 25%;
		cursor: pointer;
	}

	.rdtCounters {
		display: inline-block;
	}

	.rdtCounters > div {
		float: left;
	}

	.rdtCounter {
		height: 100px;
	}

	.rdtCounter {
		width: 40px;
	}

	.rdtCounterSeparator {
		line-height: 100px;
	}

	.rdtCounter .rdtBtn {
		height: 40%;
		line-height: 40px;
		cursor: pointer;
		display: block;

		-webkit-touch-callout: none; /* iOS Safari */
		-webkit-user-select: none; /* Chrome/Safari/Opera */
		-khtml-user-select: none; /* Konqueror */
		-moz-user-select: none; /* Firefox */
		-ms-user-select: none; /* Internet Explorer/Edge */
		user-select: none;
	}
	.rdtCounter .rdtCount {
		height: 20%;
		font-size: 1.2em;
	}

	.rdtMilli {
		vertical-align: middle;
		padding-left: 8px;
		width: 48px;
	}

	.rdtMilli input {
		background-color: transparent;
		width: 100%;
		font-size: 1.2em;
		margin-top: 37px;
	}

	.rdtTime td {
		cursor: default;
	}

	[data-background="light"] {
		.rdtPicker {
			background: #fff;
			box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
			border: 1px solid theme("colors.grey.50");
		}
		.rdtPicker td.rdtDay:hover,
		.rdtPicker td.rdtHour:hover,
		.rdtPicker td.rdtMinute:hover,
		.rdtPicker td.rdtSecond:hover,
		.rdtPicker .rdtTimeToggle:hover {
			background: theme("colors.grey.200");
		}
		.rdtPicker td.rdtOld,
		.rdtPicker td.rdtNew {
			color: theme("colors.grey.500");
		}
		.rdtPicker td.rdtToday:before {
			border-bottom: 7px solid theme("colors.blue.500");
			border-top-color: rgba(0, 0, 0, 0.2);
		}
		.rdtPicker td.rdtActive,
		.rdtPicker td.rdtActive:hover {
			background-color: theme("colors.blue.500");
			color: #fff;
		}
		.rdtPicker td.rdtActive.rdtToday:before {
			border-bottom-color: #fff;
		}
		.rdtPicker td.rdtDisabled,
		.rdtPicker td.rdtDisabled:hover {
			color: theme("colors.grey.500");
		}

		.rdtPicker td span.rdtOld {
			color: theme("colors.grey.500");
		}
		.rdtPicker td span.rdtDisabled,
		.rdtPicker td span.rdtDisabled:hover {
			color: theme("colors.grey.500");
		}
		.rdtPicker th {
			border-bottom: 1px solid theme("colors.grey.50");
		}
		.rdtPicker th.rdtDisabled,
		.rdtPicker th.rdtDisabled:hover {
			color: theme("colors.grey.500");
		}
		.rdtPicker thead tr:first-child th:hover {
			background: theme("colors.grey.200");
		}
		.rdtPicker tfoot {
			border-top: 1px solid theme("colors.grey.50");
		}
		.rdtPicker button:hover {
			background-color: theme("colors.grey.200");
		}
		td.rdtMonth:hover,
		td.rdtYear:hover {
			background: theme("colors.grey.200");
		}
		.rdtCounter .rdtBtn .rdtCounter .rdtBtn:hover {
			background: theme("colors.grey.200");
		}
	}

	[data-background="dark"] {
		.rdtPicker {
			background: theme("colors.grey.800");
			box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
			border: 1px solid theme("colors.grey.700");
		}
		.rdtPicker td.rdtDay:hover,
		.rdtPicker td.rdtHour:hover,
		.rdtPicker td.rdtMinute:hover,
		.rdtPicker td.rdtSecond:hover,
		.rdtPicker .rdtTimeToggle:hover {
			background: theme("colors.grey.600");
		}
		.rdtPicker td.rdtOld,
		.rdtPicker td.rdtNew {
			color: theme("colors.grey.700");
		}
		.rdtPicker td.rdtToday:before {
			border-bottom: 7px solid theme("colors.blue.500");
			border-top-color: rgba(0, 0, 0, 0.2);
		}
		.rdtPicker td.rdtActive,
		.rdtPicker td.rdtActive:hover {
			background-color: theme("colors.blue.500");
			color: #fff;
		}
		.rdtPicker td.rdtActive.rdtToday:before {
			border-bottom-color: theme("colors.grey.800");
		}
		.rdtPicker td.rdtDisabled,
		.rdtPicker td.rdtDisabled:hover {
			color: theme("colors.grey.700");
		}

		.rdtPicker td span.rdtOld {
			color: theme("colors.grey.700");
		}
		.rdtPicker td span.rdtDisabled,
		.rdtPicker td span.rdtDisabled:hover {
			color: theme("colors.grey.700");
		}
		.rdtPicker th {
			border-bottom: 1px solid theme("colors.grey.700");
		}
		.rdtPicker th.rdtDisabled,
		.rdtPicker th.rdtDisabled:hover {
			color: theme("colors.grey.700");
		}
		.rdtPicker thead tr:first-child th:hover {
			background: theme("colors.grey.600");
		}
		.rdtPicker tfoot {
			border-top: 1px solid theme("colors.grey.700");
		}
		.rdtPicker button:hover {
			background-color: theme("colors.grey.600");
		}
		td.rdtMonth:hover,
		td.rdtYear:hover {
			background: theme("colors.grey.600");
		}
		.rdtCounter .rdtBtn .rdtCounter .rdtBtn:hover {
			background: theme("colors.grey.600");
		}
	}
`

export const Tabs = styled.div`
	background-color: #061823;
		
	&[data-multi-lang-view='true'] {
			background-color: transparent;
	}
`

export const TabItems = styled.div`
	display: flex;
	flex-flow: row wrap;
	width: fit-content;
	&[data-vtab] {
		flex-direction: column;
		flex-shrink: 0;
	}
	justify-content: flex-start;
	align-items: center;
	gap: 10px;
	padding: 4px;
	background-color: rgba(238, 238, 238, 0.05);
	color: rgba(255, 255, 255, 0.60);
	font-family: "Basis Grotesque Pro";
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 120%; /* 19.2px */
	letter-spacing: 0.48px;

	&[data-multi-lang-view='true'] {
			background-color: transparent;
	}
`

export const TabItem = styled.div`
	flex: none;
	transition: all 0.4s;
		
	&[data-active="true"] {
		background-color: #32A0E5;
		color: #030F17;
	}
	&[data-active="false"]:hover {
		color: #FFF;
		background-color: #1675B1;
	}
	&[data-active="true"]:hover {
		color: #FFF;
	}
	.tab-button-caps &, &[data-caps="true"] {
		text-transform: uppercase;
	}

	&[data-multi-lang-view='true'] {
			background-color: transparent;
      color: var(--it-text-grey);
			border-bottom: 1px solid transparent;

      &[data-active="true"], &[data-active="false"]:hover {
          background-color: transparent;
          color: var(--it-accent-blue);
          border-bottom: 1px solid var(--it-accent-blue);
      }
  }
`

export const TabContent = styled.div`
	display: none;
	width: 100%;
	padding-top: 1rem;

	&[data-active="true"] {
		display: block;
	}
`

export const TabButton = styled.button`
	display: inline-flex;
	justify-content: center;
	align-items: center;
	gap: 16px;
	padding: 8px 24px;
	height: 32px;
	background-color: inherit;
	color: inherit;
	text-transform: inherit;

	&[data-multi-lang-view='true'] {
			background: transparent;
			text-transform: uppercase;
	}
`

export const GroupBox = styled.div`
	&[data-direction="column"] {}
	&[data-direction="row"] {}
	&[data-justify="start"] {}
	&[data-justify="end"] {}
	&[data-items="start"] {}
	&[data-items="end"] {}
	&[data-items="center"] {}
	&[data-items="stretch"] {}
`

export const DropZone = styled.div`
	background: rgba(50, 160, 229, 0.10);
	border: 1px dashed rgba(50, 160, 229, 0.20);
	height: 100%;
	cursor: pointer;
	transition: all 0.4s;
		
	&[data-active="true"], &:hover {
		border: 1px solid #32A0E5;
	}
`

export const DropInput = styled.input``

export const DropBox = styled.div`
	display: flex;
	/* width: 261px;
	height: 204px; */
	padding: 32px 20px;
	flex-flow: column wrap;
	justify-content: center;
	align-items: center;
	flex-shrink: 0;
	gap: 8px;
`

export const DropMessage = styled.div`
	margin-top: 16px;
	white-space: pre-wrap;
	outline: none;

	color: #FFF;
	text-align: center;
	font-family: "Basis Grotesque Pro";
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 120%; /* 16.8px */
	letter-spacing: 0.42px;
`

export const DropRequirements = styled.div`
	white-space: pre-wrap;
	outline: none;

	color: rgba(255, 255, 255, 0.60);
	text-align: center;
	font-family: "Basis Grotesque Pro";
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 130%; /* 15.6px */
	letter-spacing: 0.24px;
`

export const ImageBox = styled.div`
	display: flex;
	flex-flow: column wrap;
	justify-content: center;
	align-items: center;
`

export const ImagePreview = styled.img`
	object-fit: contain;
	//border: 1px dashed rgba(255, 255, 255, 0.60);
	//filter: grayscale(50%);
	/*&:hover {
		border: 1px solid #32A0E5;
	}*/
`

export const ImageRemoveButton = styled.button`
	margin-top: 12px;
		
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 8px;
	//flex: 1 0 0;
	align-self: stretch;
	padding: 8px;

	border-radius: 1px;
	background: var(--it-bg-red, rgba(228, 40, 27, 0.15));

	color: var(--it-text-red, #E4281B);
	font-family: "Basis Grotesque Pro";
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 100%; /* 16px */
	letter-spacing: 0.48px;
	text-transform: uppercase;
	transition: all 0.4s;

	span {
			margin-top: 2px;
	}
		
	&:hover {
      color: var(--it-text-dark-red);
	}
`

export const VideoBox = styled.div`
	display: flex;
	flex-flow: column wrap;
	justify-content: center;
	align-items: center;
`

export const VideoPreview = styled.video`
	object-fit: contain;
	//border: 1px dashed rgba(255, 255, 255, 0.60);
	//filter: grayscale(50%);
	/*&:hover {
		border: 1px solid #32A0E5;
	}*/
`

export const VideoRemoveButton = styled.button`
	margin-top: 12px;
		
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 8px;
	//flex: 1 0 0;
	align-self: stretch;
	padding: 8px;

	border-radius: 1px;
	background: var(--it-bg-red, rgba(228, 40, 27, 0.15));

	color: var(--it-text-red, #E4281B);
	font-family: "Basis Grotesque Pro";
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 100%; /* 16px */
	letter-spacing: 0.48px;
	text-transform: uppercase;
	transition: all 0.4s;

	span {
			margin-top: 2px;
	}

	&:hover {
			color: var(--it-text-dark-red);
	}
`

